<template>
    <div style="display: flex; flex-direction: column;">
        <div style="flex: 1;">
            <div style="margin-top: 12px;">
                <div style="margin-bottom: 12px; line-height: 20px; font-weight: 700; margin-left: 12px;">이번 주 추천 팀</div>
                <AutoScrollWrapper :scrollDirection="SCROLL_DIRECTION.LEFT" class="hide_scroll" style="display: flex; align-items: center; overflow-x: scroll; overflow-y: hidden; gap: 16px; padding: 0 12px; margin-top: 16px;">
                    <InteractionOfScale v-for="each, i in mainData.teams" :key="i" class="team_box">
                        <div style="flex: 1; overflow: hidden;" @click="showTeamDetail(each); $Util.sendEventClick('사커하우_배너_팀자세히보기', true);">
                            <img style="height: 100%; width: 100%; border-radius: 12px; object-fit: cover;" :src="$resourcePath + each.bg_image_path" alt="">
                        </div>
                    </InteractionOfScale>
                </AutoScrollWrapper>
                <div v-if="false" style="margin-bottom: 20px;">
                    <div style="margin-top:20px;" @click="showRealTimeNews">
                        <div style="display: flex; align-items: center; background-color: #210f03; padding-left: 12px;">
                            <div style="width: 32px; height: 20px; line-height: 20px; text-align: center; border-radius: 4px; font-size: 12px; background-color: #B32023; color: #fff;">LIVE</div>
                            <swiper :options="swiperOption" style="height: 44px; width: 100%;" role="tablist">
                                <swiper-slide style="background-color: #210f03; color: #fff; padding: 12px; padding-left: 7px;" v-for="each, i in real_time_news" :key="i + 'real_time_news'">
                                    <div style="display: flex; align-items: center; gap: 7px;">
                                        <div style="line-height: 20px; font-size: 12px; font-weight: 500;">
                                            <span>📢 {{ each.from_member.nic_name }}</span> 감독,
                                            <span style="font-weight: 700;">
                                                <span>{{ each.to_member.nic_name }}</span>
                                                <span style="font-weight: 700; color: var(--color-main);">
                                                    <DivisionPositionText :position="each.to_member.position" :positionProAbility="each.to_member.position_pro_ability"></DivisionPositionText>
                                                </span>
                                            </span>
                                            <span v-if="each.news_type == REAL_TIME_NEWS_TYPE.SCOUT">를 스카웃했습니다. 👏</span>
                                            <span v-else>에게 관심을 갖고 있습니다.🤔</span>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div>
                </div>
                <div style="margin-bottom: 20px;">
                    <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 20px">
                        <div class="label" style="">실시간 입단 소식</div>
                        <div v-if="!is_me_coach" @click="showCurrentScoutUser" style="display: flex; align-items: center; gap: 8px; margin-right: 12px;">
                            <div style="font-weight: 700; font-size: 12px; color: #767676;">내 스카우트 현황</div>
                            <img style="width: 8px;" :src="require('@/assets/img/arrow_gray_new.png')" alt="">
                        </div>
                    </div>
                    <div style="padding:0px 12px; margin-top:10px;" @click="showRealTimeNews">
                        <AutoScrollWrapper :scrollDirection="SCROLL_DIRECTION.TOP" style="height:120px;padding: 16px 12px; background-color: #F5F5F5; border-radius:16px;">
                            <div v-for="each, i in real_time_news" :key="i" :style="{ marginBottom: i + 1 === real_time_news.length ? '0' : '14px' }" style="display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-bottom: 32px;">
                                <div>
                                    <div style="color: #606060; font-weight: 700; font-size: 14px; line-height: 20px; margin-bottom: 4px;">{{ each.from_member.team ? each.from_member.team.name : '' }}</div>
                                    <div style="line-height: 20px; font-size: 14px; font-weight: 500;">
                                        <span>{{ each.from_member.nic_name }}</span> 감독,
                                        <span style="font-weight: 700;">
                                            <span>{{ each.to_member.nic_name }}</span>
                                            <span style="font-weight: 700; color: var(--color-main);">
                                                <DivisionPositionText :position="each.to_member.position" :positionProAbility="each.to_member.position_pro_ability"></DivisionPositionText>
                                            </span>
                                        </span>
                                        <span v-if="each.news_type == REAL_TIME_NEWS_TYPE.SCOUT">를 스카웃했습니다. 👏</span>
                                        <span v-else>에게 관심을 갖고 있습니다.🤔</span>
                                    </div>
                                    <div style="margin-top: 8px; font-size: 12px; font-weight: 500; line-height: 20px; color: #606060;">{{ each.insert_date | agoDateStr }}</div>
                                </div>
                                <div style="height: 60px; width: 60px; flex-shrink: 0; border-radius: 12px; overflow: hidden;" v-if="each.from_member.team && each.from_member.team.image_path">
                                    <img style="width: 100%; height: 100%;" :src="each.from_member.team ? $resourcePath + each.from_member.team.image_path : ''" alt="">
                                </div>
                            </div>
                        </AutoScrollWrapper>
                    </div>
                </div>
                <div style="padding: 0 12px;" v-if="is_me_coach">
                    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 20px;">
                        <!-- <img style="width: 16px;" :src="require('@/assets/img/current_scout.png')" alt=""> -->
                        <div style="font-weight: 700; line-height: 20px;">나의 스카우트 현황</div>
                    </div>
                    <div style="display: flex; gap: 14px;">
                        <div @click="showCurrentScout('request')" style="display: flex; flex-direction: column; justify-content: space-between; padding: 20px; padding-bottom: 12px; border-radius: 12px; background-color: #f5f5f5; flex: 1; height: 112px;">
                            <div style="display: flex; align-items: center; justify-content: space-between;">
                                <img style="width: 56px;" :src="require('@/assets/img/request_open.png')" alt="">
                                <div style="font-size: 20px; font-weight: 500; line-height: 24px;">
                                    <span style="font-weight: 900; font-size: 32px; line-height: 36px;">{{ receivedRequestCnt }}</span>건
                                </div>
                            </div>
                            <div style="margin-top: 4px; font-weight: 700; font-size: 14px; line-height: 20px; text-align: center;">받은 입단 요청서</div>
                        </div>
                        <div @click="showCurrentScout('favorite')" style="display: flex; flex-direction: column; justify-content: space-between; padding: 20px; padding-bottom: 12px; border-radius: 12px; background-color: #f5f5f5; flex: 1; height: 112px;">
                            <div style="display: flex; align-items: center; justify-content: space-between;">
                                <img style="width: 50px;" :src="require('@/assets/img/favorite_player.png')" alt="">
                                <div style="font-size: 20px; font-weight: 500; line-height: 24px;">
                                    <span style="font-weight: 900; font-size: 32px; line-height: 36px;">{{ favoritePlayerCnt }}</span>명
                                </div>
                            </div>
                            <div style="margin-top: 4px; font-weight: 700; font-size: 14px; line-height: 20px; text-align: center;">내가 찜한 관심 선수</div>
                        </div>
                    </div>
                    <div v-if="false" @click="goMembershipPage" style="margin-top: 20px; padding: 8px 12px; border-radius: 12px; background-color: #272123;">
                        <div style="display: flex; align-items: center; justify-content: space-between;">
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div style="border-radius: 50%; background: linear-gradient(90deg, #FF7111 0%, #C24E00 100%); width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;">
                                    <img style="width: 14px;" :src="require('@/assets/img/crown.png')" alt="" />
                                </div>
                                <div>
                                    <div style="font-weight: 700; font-size: 12px; line-height: 20px; color: var(--color-main);">SCOUT MEMBERSHIP</div>
                                    <div style="font-weight: 700; font-size: 14px; line-height: 24px; color: #fff;">멤버십으로 선수들을 스카우트 해보세요</div>
                                </div>
                            </div>
                            <div>
                                <img style="width: 8px;" :src="require('@/assets/img/arrow_white.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="false" style="padding: 0 12px;">
                    <div style="padding: 12px; margin-top: 20px; background-color: #273344; border-radius: 12px; position: relative;">
                        <div style="position: absolute; top: 50%; transform: translateY(-50%); right: 14px;">
                            <img style="width: 8px;" :src="require('@/assets/img/white_arrow_new.png')" alt="">
                        </div>
                        <div style="display: flex; align-items: center; gap: 5px;">
                            <div>
                                <img style="width: 32px;" :src="require('@/assets/img/crown_management.png')" alt="">
                            </div>
                            <div style="display: flex; flex-direction: column;">
                                <div style="color: #E7AA0B; font-weight: 500; font-size: 12px; line-height: 16px;">PREMIUM</div>
                                <div style="font-weight: 500; font-size: 12px; line-height: 16px; color: #fff;">비공개 1:1 매니지먼트가 필요하신가요?</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-else style="margin-bottom: 20px;">
                    <div class="label">스카우트 할 선수를 찾아보세요</div>
                    <div style="display: flex; gap: 16px; margin-top: 10px; padding: 0 12px;">
                        <div @click="showDirectMessageList(); $Util.sendEventClick('사커하우_선수스카웃', true)" style="flex: 1; border-radius: 12px; overflow: hidden; position: relative; background-color: #e9f3ff;">
                            <div style="position: relative; z-index: 1;">
                                <div style="display: flex;">
                                    <div style="margin-left: 12px; margin-top: 12px;">
                                        <div style="width: 49px; height: 20px; background-color: #fff; border-radius: 12px; border: 1px solid #cae1f3; display: flex; align-items: center; gap: 5px; justify-content: center;">
                                            <img style="width: 9px;" :src="require('@/assets/img/shield.png')" alt="">
                                            <div style="font-size: 12px; color: #1f59e8; font-weight: 500;">일반</div>
                                        </div>
                                        <div style="margin-top: 5px; font-weight: 700; line-height: 20px;">스카우트 할<br/>선수찾기</div>
                                    </div>
                                    <div style="position: absolute; right: 12px; top: 21px;">
                                        <img style="width: 60px;" :src="require('@/assets/img/find_player.png')" alt="">
                                    </div>
                                </div>
                                <div style="font-size: 12px; font-weight: 700; line-height: 20px; color: #387bf5; margin-left: 12px; margin-bottom: 11px; margin-top: 13px;">눈여겨본 선수에게 입단 제안하기</div>
                            </div>
                        </div>
                        <div @click="showSecretAgentPage" style="flex: 1; border-radius: 12px; position: relative; overflow: hidden; background-color: #1A1F2B; ">
                            <div style="position: relative; z-index: 1;">
                                <div style="display: flex;">
                                    <div style="margin-left: 12px; margin-top: 12px; margin-bottom: 11px;">
                                        <div style="width: 86px; height: 20px;background: linear-gradient(90deg, #F9C214 0%, #F96C16 100%); border-radius: 12px; display: flex; align-items: center; gap: 5px; justify-content: center;">
                                            <img style="width: 12px;" :src="require('@/assets/img/crown.png')" alt="">
                                            <div style="font-size: 12px; font-weight: 500; color: #fff;">PREMIUM</div>
                                        </div>
                                        <div style="color: #fff; font-weight: 700;">
                                            <div style="margin-top: 5px; line-height: 20px;">시크릿<br/>에이전트</div>
                                        </div>
                                        <div style="display: flex; align-items: center; gap: 5px; margin-top: 2px;">
                                            <div style="width: 20px; height: 1px; background-color: #f9be14;"></div>
                                            <div style="font-size: 12px; line-height: 16px; color: #f9be14; font-weight: 500;">ELITE MATCHING</div>
                                        </div>
                                        <div style="color: #A9A9A9; font-size: 10px; line-height: 16px;">검증된 선수 비공개 추천</div>
                                    </div>
                                    <div style="position: absolute; right: 5px; top: 19px;">
                                        <img style="width: 65px;" :src="require('@/assets/img/secret_coach.png')" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div style="margin-top: 20px;">
                    <div style="padding: 0 12px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                        <div style="font-weight: 700; line-height: 20px;">🔥 실시간 이적 시장</div> 
                        <div style="display: flex; align-items: center; gap: 4px; font-size: 12px; font-weight: 700; line-height: 24px;">
                            <img style="width: 13px;" :src="require('@/assets/img/verified_parent.png')" alt="">: 부모님 인증 완료 선수
                        </div>
                    </div>
                    <div v-for="each, i in shortRequest" :key="i + 'request_form'" :style="{ paddingBottom: i === 1 ? '20px' : '40px' }" style="padding: 0 12px;">
                        <CommonSecretRequestForm :completeAction="refresh" v-if="each.is_secret == 1" :userInfo="each" />
                        <CommonRequestForm :completeAction="refresh" v-else :userInfo="each" />
                        <div v-if="!is_me_coach && i === 1" style="margin-top: 20px;">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div style="padding-left: 0;" class="label">축구선수의 꿈, 현실로 만드세요!</div>
                            </div>
                            <div style="display: flex; gap: 16px; margin-top: 20px;">
                                <div style="">
                                    <div @click="confirmSoccerhowDraft(); $Util.sendEventClick('축구팀입단_축구선수가_되고싶나요_배너', true)">
                                        <img style="width: 100%; height: 100%;" :src="require('@/assets/img/join_request_back.png')" alt="">
                                    </div>
                                </div>
                            </div>
                            <div v-if="false" style="padding: 0 12px;">
                                <div style="padding: 12px; margin-top: 20px; background-color: #273344; border-radius: 12px; position: relative;">
                                    <div style="position: absolute; top: 50%; transform: translateY(-50%); right: 14px;">
                                        <img style="width: 8px;" :src="require('@/assets/img/white_arrow_new.png')" alt="">
                                    </div>
                                    <div style="display: flex; align-items: center; gap: 5px;">
                                        <div>
                                            <img style="width: 32px;" :src="require('@/assets/img/crown_management.png')" alt="">
                                        </div>
                                        <div style="display: flex; flex-direction: column;">
                                            <div style="color: #E7AA0B; font-weight: 500; font-size: 12px; line-height: 16px;">PREMIUM</div>
                                            <div style="font-weight: 500; font-size: 12px; line-height: 16px; color: #fff;">비공개 1:1 매니지먼트가 필요하신가요?</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="false" style="padding: 0 12px;">
                    <div style="margin-bottom: 32px; " v-for="each, i in noticeList" :key="i + 'notice'">
                        <CommonNoticePost style="padding: 12px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); border-radius: 12px;" :isNeedWrittenCheck="true" :isFeed="false" :completeAction="hideNoticeList" :index="i" :noticePost="each"></CommonNoticePost>
                    </div>
                    <div style="margin-bottom: 32px; " v-for="each, i in shortRequest" :key="i + 'post'">
                        <InteractionOfScale>
                            <CommonPost style="padding: 12px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); border-radius: 12px;" :isNeedWrittenCheck="true" :refresh="refresh" :isExpertConfirmed="isExpertConfirmed" :isExpert="isExpert" :soccerHows="each"></CommonPost>
                        </InteractionOfScale>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <InteractionOfScale :scaleNumber="'0.91'" :style="{ bottom: 80 + navagaionBarHeight + 'px' }" v-if="is_show_feed_add_btn && !isExpert" style="position:fixed; right: 12px;">
                <div @click="addFeed">
                    <img :src="require('@/assets/img/feed_add_btn.png')" style="width:52px; height:52px;">
                </div>
            </InteractionOfScale>
        </transition>
        <Transition name="fade">
            <div v-if="isShowPopup" style="position: fixed; z-index: 200; background: #210F0380; width: 100%; height: 100%; left: 0; top: 0; backdrop-filter: blur(10px);">
                <div style="width: 350px; padding-bottom: 40px; text-align: center; border-radius: 24px; background-color: #fff; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                    <div class="text_gradient_popup" style="font-weight: 800; font-size: 32px; line-height: 32px; padding-top: 50px;">9,900원!</div>
                    <div style="font-weight: 700; font-size: 12px; color: #bbbbbb; margin-top: 10px;">평균 20,000원</div>
                    <div style="font-weight: 700; font-size: 20px; line-height: 32px; margin-top: 17px;">딱 한달만 진행되는<br>트레이닝 이벤트</div>
                    <div style="margin-top: 8px; font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">평균 2만원이 넘는 축구 트레이닝을 단 9,900원으로.<br>근처에서 가능한 트레이닝을 바로 확인해보세요.</div>
                    <div @click="closePopup" style="width: 196px; height: 56px; line-height: 56px; text-align: center; font-weight: 700; font-size: 14px; color: var(--color-main); margin: 0 auto; background-color: #210f03; border-radius: 50px; margin-top: 40px;">가까운 수업 확인하기</div>
                </div>
            </div>
        </Transition>
        <AfterFindPositionPopup :btnClickEvent="addFeed" :popupType="AFTER_POSITION_POPUP_TYPE.SOCCER_JOIN"></AfterFindPositionPopup>
        <CommonConfirmFrame v-if="isShowConfirmPopup" :isShowConfirmPopup="isShowConfirmPopup" :closeConfirmPopup="closeConfirmPopup">
            <div class="confirm_draft_content">
                <div @click="closeConfirmPopup" class="confirm_close_btn">
                    <img style="width: 14px;" :src="require('@/assets/img/x_btn_gray.png')" alt="">
                </div>
                <div class="confirm_icon_wrapper">
                    <img style="width: 17px;" :src="require('@/assets/img/writing_request.png')" alt="">
                </div>
                <div class="confirm_title">작성 중인 요청서가 있어요!</div>
                <div class="confirm_desc">
                    이전에 임시 저장된 내용부터<br>이어서 작성하시겠어요?
                </div>
                <div class="confirm_btn_row">
                    <div @click="deleteDraft" class="confirm_btn_new">새로 작성하기</div>
                    <div @click="writeDefaultInfoForm" class="confirm_btn_continue">이어서 작성하기</div>
                </div>
            </div>
        </CommonConfirmFrame>
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { REAL_TIME_NEWS_TYPE, SCROLL_DIRECTION, AFTER_POSITION_POPUP_TYPE } from '@/Constants'
import CommonPost from '@/components/soccerhowmain/CommonPost'
import InteractionOfScale from '@/components/common/InteractionOfScale'
import CommonNoticePost from '@/components/common/CommonNoticePost'
import AutoScrollWrapper from '@/components/common/AutoScrollWrapper'
import AfterFindPositionPopup from '@/components/common/AfterFindPositionPopup'
import DivisionPositionText from '@/components/common/DivisionPositionText'
import CommonRequestForm from '@/components/common/CommonRequestForm'
import CommonConfirmFrame from '@/components/common/CommonConfirmFrame'
import ResponseCode from '@/ResponseCode'
import CommonSecretRequestForm from '@/components/common/CommonSecretRequestForm'

export default {
    name: 'JoinSoccerTeam',
    components: { CommonPost, CommonSecretRequestForm, AutoScrollWrapper, DivisionPositionText, AfterFindPositionPopup, InteractionOfScale, CommonNoticePost, swiper, swiperSlide, CommonRequestForm, CommonConfirmFrame },
    props: {
        refreshFlag: {
            type: Boolean,
            default: false
        },
        initRefreshFlag: {
            type: Function,
            default: () => { }
        },
        setBookmarkPopup: {
            type: Function,
            default: () => { }
        },
        setMakeRequestJoinForm: {
            type: Function,
            default: () => { }
        },
        mainData: {
            type: Object,
            default: () => { }
        },
        shortRequest: {
            type: Array,
            default: () => { }
        },
        isExpert: {
            type: Boolean,
            default: false
        },
        isExpertConfirmed: {
            type: Boolean,
            default: false
        },
        refresh: {
            type: Function,
            default: () => { }
        },
        noticeList: {
            type: Array,
            default: () => { }
        },
        hideNoticeList: {
            type: Function,
            default: () => { }
        }
    },
    computed: {
        is_me_coach() {
            if (this.$GlobalStore.isLogin()) {
                if (this.$GlobalStore.loginInfo().is_temp_coach == 1) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        }
    },
    data() {
        return {
            AFTER_POSITION_POPUP_TYPE: AFTER_POSITION_POPUP_TYPE,
            isShowBookmarkPopup: false,
            SCROLL_DIRECTION: SCROLL_DIRECTION,
            swiperOption: {
                direction: 'vertical',
                // slidesPerView: 'auto',
                spaceBetween: 0, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                allowTouchMove: false, // 스와이프 금지
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                autoplay: {
                    delay: 3000
                },
                curIndex: 0,
            },
            scrollPosition: 0, // 스크롤 위치
            scrollSpeed: 1, // 스크롤 속도
            intervalId: null, // setInterval ID
            items: [
                // { name: '부천유나이티드 U12', contents: '박지원 감독, 유지원 RB를 스카웃했습니다.', date: '2024.12.13.' },
                // { name: '니케FC U12', contents: '박지원 감독, 유지원 RB를 스카웃했습니다.', date: '2024.12.13.' },
                // { name: '인천리틀코리아FC U12', contents: '박지원 감독, 유지원 RB를 스카웃했습니다.', date: '2024.12.13.' },
                // { name: '비야레알CF', contents: '박지원 감독, 유지원 RB를 스카웃했습니다.', date: '2024.12.13.' },
            ],
            is_show_feed_add_btn: false,
            navagaionBarHeight: 0,
            isShowPopup: false,
            real_time_news: [],
            REAL_TIME_NEWS_TYPE: REAL_TIME_NEWS_TYPE,
            isShowConfirmPopup: false,
            soccerhow_draft: null,
            receivedRequestCnt: 0,
            favoritePlayerCnt: 0,
        }
    },
    mounted() {
        // this.startScroll()
        this.getRealTimeNews()
    },
    created() {
        this.navagaionBarHeight = this.$GlobalStore.navigationBarHeight()
        if (this.is_me_coach) {
            this.myCurrentScout()
        }
    },
    beforeDestroy() {
        this.stopScroll();
    },
    deactivated() {
        if (this.real_time_news_interval) clearInterval(this.real_time_news_interval);
    },
    methods: {
        goMembershipPage() {
            this.$GlobalStore.addModal('MembershipGuide')
        },
        showConfirmSoccerhowDraft(soccerhow_draft) {
            this.soccerhow_draft = soccerhow_draft
            this.isShowConfirmPopup = true
        },
        showCurrentScoutUser() {
            if (this.$GlobalStore.loginInfo().is_secret == 1) {
                this.$GlobalStore.addModal('CurrentScoutUserSecret')
            } else {
                this.$GlobalStore.addModal('CurrentScoutUser')
            }
        },
        async deleteDraft() {
            const res = await this.$Axios.post('/api/soccerhow/delete/draft')
            if (res.data.code === 0) {
                this.isShowConfirmPopup = false
                this.$GlobalStore.addModal('MakeFeedSoccerJoin', {
                    isModalBackTransparent: true,
                    completeAction: this.refresh(),
                    transitionName: 'bottom',
                })
            }
        },
        closeConfirmPopup() {
            this.isShowConfirmPopup = false
        },
        async confirmSoccerhowDraft() {
            const res = await this.$Axios.get('/api/soccerhow/get/draft')
            if (res.data.soccerhow_draft) {
                this.isShowConfirmPopup = true
                this.soccerhow_draft = res.data.soccerhow_draft
            } else {
                this.$GlobalStore.addModal('MakeFeedSoccerJoin', {
                    isModalBackTransparent: true,
                    completeAction: this.refresh(),
                    transitionName: 'bottom',
                })
            }
        },
        writeDefaultInfoForm() {
            this.isShowConfirmPopup = false
            this.$GlobalStore.addModal('WriteDefaultInfoForm', { soccerhowDraft: this.soccerhow_draft, isDraft: true, playerType: this.soccerhow_draft.player_type })
        },
        selectPlayerType() {
            this.$GlobalStore.addModal('SelectPlayerType')
        },
        showCurrentScout(type) {
            this.$GlobalStore.addModal('CurrentScout', { parentType: type })
        },
        showSecretAgentPage() {
            this.$GlobalStore.addModal('SecretAgent')
        },
        async myCurrentScout() {
            const res =  await this.$Axios.get('/api/coach/scouting/my_current')
            if (res.data.code === ResponseCode.SUCCESS) {
                this.receivedRequestCnt = res.data.received_request_cnt
                this.favoritePlayerCnt = res.data.favorite_player_cnt
            }
        },
        async getRealTimeNews() {
            const parameters = {}
            parameters.page_type = 'join_soccer_team'
            const res = await this.$Axios.get('/api/home', { params: parameters });
            this.real_time_news = res.data.real_time_news;
            this.exceptionManager()
        },
        exceptionManager() {
            if (process.env.NODE_ENV === 'production') {
                this.real_time_news = this.real_time_news.filter(item => 
                    item.from_member_idx != 462310 && item.to_member_idx != 462310
                );
            }
        },
        showRealTimeNews() {
            this.$Util.sendEventClick('축구팀입단_실시간_입단_소식', true)
            this.$GlobalStore.addModal('SoccerhowRealTimeNews')
        },
        closePopup() {
            this.isShowPopup = false
        },
        setIsShowPopup() {
            this.isShowPopup = true
        },
        addFeed() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.setMakeRequestJoinForm();
            this.$Util.sendEventClick('사커하우_요청서작성')
        },
        __detectScroll(e) {
            e;
            if (this.$refs.feed_add_btn_wrap) {
                const rect = this.$refs.feed_add_btn_wrap.getBoundingClientRect()
                if (rect.bottom < 56) {
                    this.is_show_feed_add_btn = true;
                } else {
                    this.is_show_feed_add_btn = false;
                }
            }
        },
        async showTeamDetail(teamDetail) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            const isWrittenRequestForm = await this.$Util.checkIsWriteRequestForm()
            if (!isWrittenRequestForm) {
                return
            }
            // this.$Util.interectionOfBtn(this.$refs.test[0])
            this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: teamDetail.idx })
            // this.$Util.checkAppLinkPageShow();
        },
        showDirectMessageList() {
            if (!this.isExpertConfirmed) {
                this.$GlobalStore.setIsShowBookmarkPopupNotExpert()
                return
            }
            this.$GlobalStore.addModal('DirectMessageList', { transitionName: 'bottom' })
            // this.$Util.checkAppLinkPageShow();
        },
        showInterviewDetail() {
            this.$GlobalStore.addModal('InterviewDetail',)
            // this.$Util.checkAppLinkPageShow();
        },
        setBookmark(index, teamDetail) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            this.setBookmarkPopup(index, teamDetail)
        },
        startScroll() {
            const list = this.$refs.scoutList;
            const listHeight = list.offsetHeight / 2;

            this.intervalId = setInterval(() => {
                this.scrollPosition -= this.scrollSpeed;

                if (Math.abs(this.scrollPosition) >= listHeight + 5) {
                    this.scrollPosition = 0;
                }
            }, 16);
        },
        stopScroll() {
            clearInterval(this.intervalId);
        },
        showSpotLightList() {
            this.$GlobalStore.addModal('SpotLightList')
            // this.$Util.checkAppLinkPageShow();
        },
    },
    watch: {
        refreshFlag(newVal) {
            if (newVal) {
                this.initRefreshFlag()
            }
        }
    }
}
</script>

<style scoped>
.label {
    padding: 0px 12px;
    font-weight: 700;
    line-height: 20px;
}

.team_box {
    width: 130px;
    height: 130px;
    border-radius: 12px;
    flex-shrink: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border: 1px solid #ebebeb;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.scout_box_wrapper {
    height: 400px;
    border-radius: 12px;
    background-image: url('~@/assets/img/scout_back.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    margin-top: 12px;
    margin-bottom: 40px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow: hidden;
}

.scout_box {
    border-radius: 12px;
    background: #210F03E5;
    border-left: 20px solid var(--color-main);
    color: #fff;
    position: relative;
    z-index: 2;
}

.box_title {
    width: 220px;
    border-radius: 12px;
    height: 120px;
    background: linear-gradient(90deg, rgba(17, 88, 255, 0.2) 0%, rgba(255, 113, 17, 0.2) 100%);
    padding: 12px;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: #606060;
}

.ellipsis_multiple_three {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s;
}

.fade-enter {
    opacity: 0;
    /* 요소가 나타날 때 초기 상태 */
}

.fade-leave-to {
    opacity: 0;
    /* 요소가 사라질 때 최종 상태 */
}

.confirm_draft_content {
    position: relative;
    /* min-width: 280px; */
    padding-top: 20px;
}

.confirm_close_btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0px 1px 9.1px 0px #00000014;
    cursor: pointer;
}

.confirm_icon_wrapper {
    width: 40px;
    height: 40px;
    margin: 0 auto 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #FF71111A;
}

.confirm_title {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 5px;
}

.confirm_desc {
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #808080;
    margin-bottom: 30px;
}

.confirm_btn_row {
    display: flex;
    gap: 12px;
}

.confirm_btn_new {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 1px solid #210F03;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    flex-basis: 35%;
}

.confirm_btn_continue {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background-color: var(--color-main);
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    flex-basis: 65%;
}
</style>